<template>
    <div class="icon-input">
        <inputIcon :id="id" ref='fileIcon'
                   icon_name="form_upload"
                   :placeholder="placeholder"
                   class="input-upload"
                   type="file"
                   accept=".png, .jpg, .jpeg"
                   :multiple = "multiple"
                   v-bind="$attrs"
                   @change.native="change_file_name($event)"
                   v-on="$listeners"
        />
        <label :for="id" class="input-upload__label">{{ has_file_name }}</label>
        <!-- <img v-if='preview' :src='preview' style="max-height: 100px"> -->
    </div>
</template>

<script>
import inputIcon from '@/components/ui/inputs/typed/input_icon.vue';

export default {
  components: {
    inputIcon,
  },
  props: {
    icon_name: {
      type: String,
    },
    error: {
      type: Boolean,
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    multiple: {
      type   : Boolean,
      default: false,
    },
  },
  data() {
    return {
      file_name: '',
      preview  : null,
      errorSize: false,
    };
  },
  computed: {
    has_file_name: function() {
      return this.file_name || this.placeholder;
    },
  },
  methods: {
    change_file_name($event) {
      let files = $event.target.files;
      let name;
      let result = [];
      for (let i=0; i < files.length; i++) {
        if (i === files.length - 1) {
          name = files[i].name;
        } else {
          name = files[i].name + ', ';
        }

        this.$emit('setFile', files[i].size);

        let reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = () => {
          if (files.length==1 && reader.result.includes('data:image')) {
            this.preview = reader.result;
          }
          this.$emit('input', reader.result);
          result.push(reader.result);
        };
      }
      this.file_name = name;
    },
  },
};
</script>
